/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { AdviceSeverities, AdviceTypes } from '../../consts';
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({
  organizationId: ZodTypes.Id,
  projectId: ZodTypes.Id,
  serviceId: ZodTypes.Id,
});

export const PutDismissedAdvice = {
  id: 'dismissed-advice.put',
  tag: 'Advice',
  summary: 'Dismiss advice',
  description: 'Hide advice so it wont be returned',
  method: 'put',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) =>
    `/organization/${params.organizationId}/project/${params.projectId}/cluster/${params.serviceId}/dismissed-advice`,
  request: {
    params: Params,
    body: {
      content: {
        'application/json': {
          schema: z.strictObject({
            info: z.string(),
            type: z.enum(AdviceTypes),
            severity: z.enum(AdviceSeverities),
            object: z.string().optional(),
            subObject: z.string().optional(),
          }),
        },
      },
    },
  },
  response: { 200: { description: 'successful', content: { 'application/json': { schema: z.string().optional() } } } },
} as const satisfies Endpoint;
